/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { UserService } from '../services/user.service';

const userState = {
  assumed: false,
  assumeParam: false,
  token: '',
  user: null,
  preventLogin: false,
};

const mutations = {
  setToken(state, token) {
    state.token = token;
    window.auth = token;
  },
  setUser(state, user) {
    state.user = user;
  },
  setAssumed(state, assumed) {
    state.assumed = parseInt(assumed, 10);
  },
  setAssumeParam(state, assume) {
    state.assumeParam = assume;
  },
  unsetToken(state) {
    state.token = null;
    window.auth = null;
  },
  unsetUser(state) {
    state.user = null;
    state.assumed = false;
  },
  prevent(state, prevent) {
    state.preventLogin = prevent;
  },
};

const getters = {
  token: state => state.token,
  user: state => state.user,
  assumed: state => state.assumed,
  assumeParam: state => state.assumeParam,
  permission: state => (state.user ? state.user.permission_id : false),
  preventLogin: state => state.preventLogin,
};

const actions = {
  login: async ({ commit, dispatch }, { email, password, tokenOnly = false }) => {
    try {
      const user = await UserService.login({ email, password });
      commit('setToken', user.token);

      if (!tokenOnly) {
        await dispatch('getUser');
        return user;
      }

      return user.token;
    } catch (e) {
      return false;
    }
  },
  logout: async ({ commit }, withoutBackend) => {
    try {
      if (!withoutBackend) {
        await UserService.logout();
      }
      commit('unsetUser');
      commit('unsetToken');
      commit('AccountManager/unsetAccount', null, { root: true });
      return true;
    } catch (e) {
      return false;
    }
  },
  unsetUser: async ({ commit }) => {
    commit('unsetUser');
    commit('unsetToken');
    commit('AccountManager/unsetAccount', null, { root: true });
  },
  // eslint-disable-next-line
  createUser: async ({}, { account_name, email, password, name, parent_account_id, category_id, ppv, shopping, phone }) => {
    if (account_name === '' || email === '' || category_id === null || ppv === null || shopping === null) {
      return { error: true };
    }

    try {
      // eslint-disable-next-line
      const user = await UserService.createUser({ account_name, email, password, name, parent_account_id, category_id, ppv, shopping, phone });
      return { user };
    } catch (e) {
      return { error: typeof e.error !== 'undefined' ? e.error : e };
    }
  },
  resetPassword: async ({}, email) => {
    await UserService.resetPassword(email);
    return true;
  },
  resetPasswordCange: async ({}, { token, password }) => {
    try {
      await UserService.resetPasswordCange(token, password);
      return true;
    } catch (e) {
      return false;
    }
  },
  changePassword: async ({}, password) => {
    try {
      await UserService.changePassword(password);
      return true;
    } catch (e) {
      return false;
    }
  },
  getUser: async ({ commit, state }) => {
    try {
      const user = await UserService.getUser();
      commit('setUser', user.user);
      if (!!state.assumeParam === false) {
        commit('setAssumed', user.assumed);
      }
      return user;
    } catch (e) {
      return false;
    }
  },
  verify: async ({ commit, state }) => {
    try {
      const verify = await UserService.verify();
      if (!!state.assumeParam === false) {
        commit('setAssumed', verify.assumed);
      }
      return true;
    } catch (e) {
      return e;
    }
  },
};

export default {
  namespaced: true,
  state: userState,
  mutations,
  actions,
  getters,
};
